<div class="form-group mg-b-10-force">
    <label class="form-control-label">{{ TitleSow }}</label>
    <div class="input-group">
      <span class="input-group-addon"><i class="icon ion-calendar tx-16 lh-0 op-6"></i></span>
      <input type="text" class="form-control fc-datepicker hasDatepicker" placeholder="MM/DD/YYYY"
        id="dp1676555954926">
    </div>
  </div> 